module.exports = __webpack_public_path__ + "img/img13.5e0426bf.png";